// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2020-11-11T11:31:32+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  107160
//    Project:        120
//    Environment:    234 - master
//    MD5:            2682dc5f41a1b8f5c96b06387ff0fe19
//    Signature:      eyJpdiI6ImxYXC8yclZ0ZFlWdFFmcmVOaXFpelZ3PT0iLCJ2YWx1ZSI6Im50TTJEeExOS0ZRZWxsV1BEd0lqYUZibnAydmJyeFNzaDIwUURWY2FXOG5WUXRpZnBTeGRlUjExWnZXQ0lqRXpXYjk2empCOHVEN3VERXJ6dU52V1R6dDBNQlBFOVwvQ3RIS1Z2NDVxcVFkZ2lpYU05STlidytIRDJoY040V0lkR3RrNWlNK2NmME9Ybm1sMjAwUjNqblBsaFZ1YXlTS3NQVVJWNFd2c0h4RkgzS0VkaDRqcFNUQk5WRWZZVGVmWm1tSUVNUjhZSUl6dTlUUmVPMWtHM1krNFFKVjNWb0FOeXZpVkNZVld3c1o2OUdqMnVBVEZQMkNlbGxHamFHNjNLTFBqU1Q5V1wvRHZjektQa1g2WkF1anhjaXZhMkNCOXJzSlBMQXRGcitNQ0lkckVcL0h6QXNQTmllVjhzQ25xRzRQRnNxZzlOUU9aZGF6aml5VjlCT1dhUG9lMlwvTzRWb0tMWEQrZldyUWlpUUhWcXQycDZxN1dSWmtuVlE2bnZXZGo0c29wbForaXJxMVU5V0RtbDBDUkx3PT0iLCJtYWMiOiI4Zjk3OTg0YTM4MjI0MjZiM2IwMmY3MDJhYjg5MGJiZTIxYzQ0OWQyYzFkOWYwMDEyMzc3YjY0OTQ3YzA4YzgxIn0=
window.theme = window.theme || {};

window.theme = theme || {};

theme.customerTemplates = (function() {

  function initEventListeners() {
    // Show reset password form
    $('#RecoverPassword').on('click', function(evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    });

    // Hide reset password form
    $('#HideRecoverPasswordLink').on('click', function(evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    });
  }

  /**
   *
   *  Show/Hide recover password form
   *
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
    $('#LoginTitle').toggleClass('login');
  }

  /**
   *
   *  Show reset password success message
   *
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }

  /**
   *
   *  Show/hide customer address forms
   *
   */
  function customerAddressForm() {
    var $newAddressForm = $('#AddressNewForm');

    if (!$newAddressForm.length) {
      return;
    }

    // Initialize observers on address selectors, defined in shopify_common.js
    if (Shopify) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
        hideElement: 'AddressProvinceContainerNew'
      });
    }

    // Initialize each edit form's country/province selector
    $('.address-country-option').each(function() {
      var formId = $(this).data('form-id');
      var countrySelector = 'AddressCountry_' + formId;
      var provinceSelector = 'AddressProvince_' + formId;
      var containerSelector = 'AddressProvinceContainer_' + formId;

      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
        hideElement: containerSelector
      });
    });

    // Toggle new/edit address forms
    $('.address-new-toggle').on('click', function() {
    	$(this).toggleClass('hide');
      $newAddressForm.toggleClass('hide');
    });
     $('.address-new-toggle-cancel').on('click', function() {
    	$('.address-new-toggle').removeClass('hide');
      	$newAddressForm.toggleClass('hide');
    });

    $('.address-edit-toggle').on('click', function(e) {
      e.preventDefault();
      var formId = $(this).data('form-id');
      $('#EditAddress_' + formId).toggleClass('hide');
      $('#AddressNewBox').toggleClass('hide');
      
    });

    $('.address-delete').on('click', function(e) {
      e.preventDefault();
      var $el = $(this);
      var formId = $el.data('form-id');
      var confirmMessage = $el.data('confirm-message');

      // eslint-disable-next-line no-alert
      if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
        Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
      }
    });
  }

  /**
   *
   *  Check URL for reset password hash
   *
   */
  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  return {
    init: function() {
      checkUrlHash();
      initEventListeners();
      resetPasswordSuccess();
      customerAddressForm();
    }
  };
})();





theme.init = function() {
  theme.customerTemplates.init();
};

$(theme.init);